import React, { useState } from "react";
import { Form, Button, Dropdown } from "semantic-ui-react";
import { axiosInstance } from "../../fetcher";

const UpdateUser = ({ user, setSelectedUser, fetchUsers }) => {
  const [email, setEmail] = useState(user?.email || "");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState(user?.phone_number || "");
  const [role, setRole] = useState(user?.role || "user");

  const roleOptions = [
    { key: "user", text: "User", value: "user" },
    { key: "admin", text: "Admin", value: "admin" },
  ];

  const handleSubmit = async () => {
    try {
      const updateData = {};
      if (email) updateData.email = email;
      if (password) updateData.password = password;
      if (phone) updateData.phone_number = phone;
      if (role) updateData.role = role;

      const response = await axiosInstance.put(
        `/auth/admin/update-user?target_username=${user.username}`,
        updateData
      );
      if (response.status === 200) {
        fetchUsers();
        setSelectedUser(null);
        alert("User updated successfully!");
      }
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  return (
    <Form
      style={{
        background: "white",
        width: "80vh",
        padding: "20px",
        border: "1px solid #D3D3D3",
        shadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Form.Input
        label="Email"
        type="email"
        placeholder="Enter email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <Form.Input
        label="Password"
        type="password"
        placeholder="Enter new password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      {/* <Form.Input
        label="Phone Number"
        type="tel"
        placeholder="Enter phone number"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
      /> */}
      <Form.Field>
        <label>Role</label>
        <select
          value={role}
          onChange={(e) => setRole(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            margin: "10px 0",
            borderRadius: "5px",
            border: "1px solid #ccc",
            fontSize: "16px",
            backgroundColor: "#fff",
          }}
        >
          <option value="user">User</option>
          <option value="admin">Admin</option>
        </select>
      </Form.Field>
      <Button color="teal" onClick={handleSubmit}>
        Update User
      </Button>
    </Form>
  );
};

export default UpdateUser;
